module.exports = __webpack_public_path__ + "img/axis.85c974d6.png";